import classNames from "classnames";
import { Button } from "@/components";
import type { ApiDeviceBranding } from "../../_types/device-brandings.types";
import { BrandingListItem } from "../branding-list-item";
import styles from "./BrandingsList.module.scss";

type BrandingsListProps = {
  items: ApiDeviceBranding[];
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
  onRetry: () => void;
  onRowClick: (id: string) => void;
  onEdit: (branding: ApiDeviceBranding) => void;
  onDuplicate: (branding: ApiDeviceBranding) => void;
  onRequestDelete: (branding: ApiDeviceBranding) => void;
  actionsDisabled: boolean;
};

export const BrandingsList = ({
  items,
  isLoading,
  isFetching,
  isError,
  onRetry,
  onRowClick,
  onEdit,
  onDuplicate,
  onRequestDelete,
  actionsDisabled,
}: BrandingsListProps) => {
  if (isLoading) {
    return (
      <div className={styles["comp__state"]}>
        <div className={styles["comp__spinner"]} />
        <div>Loading branding…</div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className={styles["comp__state"]}>
        <div>Could not load branding.</div>
        <Button size="small" variant="secondary" onClick={onRetry}>
          Retry
        </Button>
      </div>
    );
  }

  if (items.length === 0) {
    return (
      <div className={styles["comp__state"]}>
        No prototype branding packages yet. Create one to explore the preview UI (not saved to the
        API).
      </div>
    );
  }

  return (
    <div className={styles["comp"]} aria-busy={isFetching}>
      <div className={styles["comp__table-header"]}>
        <div className={styles["comp__column"]}>Name</div>
        <div className={styles["comp__column"]}>Display name</div>
        <div className={styles["comp__column"]}>Accent</div>
        <div className={styles["comp__column"]}>Updated</div>
        <div className={classNames(styles["comp__column"], styles["comp__column--actions"])}>Actions</div>
      </div>

      <div className={styles["comp__list"]}>
        {items.map((b) => (
          <BrandingListItem
            key={b.id}
            branding={b}
            onRowClick={() => onRowClick(b.id)}
            onEdit={() => onEdit(b)}
            onDuplicate={() => onDuplicate(b)}
            onRequestDelete={() => onRequestDelete(b)}
            actionsDisabled={actionsDisabled}
          />
        ))}
      </div>
    </div>
  );
};
